"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _ = __importStar(require("lodash"));
var RichTextEditor_1 = require("./RichTextEditor");
var bold_icon_svg_1 = __importDefault(require("res/img/bold-icon.svg"));
var italic_icon_svg_1 = __importDefault(require("res/img/italic-icon.svg"));
var title_icon_svg_1 = __importDefault(require("res/img/title-icon.svg"));
var unordered_list_icon_svg_1 = __importDefault(require("res/img/unordered-list-icon.svg"));
var ordered_list_icon_svg_1 = __importDefault(require("res/img/ordered-list-icon.svg"));
var RichTextEditorControlButton = function (_a) {
    var controlName = _a.controlName, selected = _a.selected, onMouseDown = _a.onMouseDown;
    var label = _.startCase(controlName.toLowerCase().replace('header-two', 'title'));
    var getIcon = function () {
        switch (controlName) {
            case RichTextEditor_1.STYLES.BOLD:
                return bold_icon_svg_1.default;
            case RichTextEditor_1.STYLES.ITALIC:
                return italic_icon_svg_1.default;
            case RichTextEditor_1.BLOCKS.HEADER_TWO:
                return title_icon_svg_1.default;
            case RichTextEditor_1.BLOCKS.UNORDERED_LIST_ITEM:
                return unordered_list_icon_svg_1.default;
            case RichTextEditor_1.BLOCKS.ORDERED_LIST_ITEM:
                return ordered_list_icon_svg_1.default;
            default:
                return null;
        }
    };
    return (react_1.default.createElement("button", { className: 'rich-text-editor-control-button', "aria-label": label, "aria-selected": selected, onMouseDown: function (e) { e.preventDefault(); onMouseDown(controlName); }, title: label },
        react_1.default.createElement("img", { src: getIcon(), alt: label })));
};
exports.default = RichTextEditorControlButton;
